import localStorageService from "app/services/localStorageService";

const $auth = localStorageService.getItem("auth_user");

let dashboardPath = "/";

if ($auth !== null) {
  switch ($auth.role) {
    case "SA":
      break;

    case "ADMIN":
    case "SECRETARIA":
    case "FINANCEIRO":
      dashboardPath = "/dashboard/admin";
      break;
    case "PROFESSOR":
      dashboardPath = "/dashboard/professor";
      break;
    default:
      dashboardPath = "/";
      break;
  }
}

const navigationsSecretaria = [
  {
    name: "Dashboard",
    description: "Dashboard",
    type: "link",
    icon: "i-Dashboard",
    path: dashboardPath,
  },
  {
    name: "Administração",
    description: "Administração",
    type: "dropDown",
    icon: "i-One-Window",
    sub: [
      {
        icon: "i-Gears",
        name: "Parâmetros",
        path: "/escola/parametros",
        type: "link",
      },
      {
        icon: "i-Business-Mens",
        name: "Usuários",
        path: "/usuario/consulta",
        type: "link",
      },
      {
        icon: "i-Conference",
        name: "Visitas",
        path: "/visita/consulta",
        type: "link",
      },
      {
        icon: "i-Link",
        name: "Convênios",
        path: "/convenio/consulta",
        type: "link",
      },
      {
        icon: "i-File-Edit",
        name: "Contrato",
        path: "/contrato/cadastro",
        type: "link",
      },
      {
        icon: "i-Consulting",
        name: "Serviços",
        path: "/servico/consulta",
        type: "link",
      },
    ],
  },
  {
    name: "Acadêmico",
    description: "Acadêmico",
    type: "dropDown",
    icon: "i-Student-Hat-2",
    sub: [
      {
        icon: "i-Check",
        name: "Chamada",
        path: "/chamada/cadastro",
        type: "link",
      },
      {
        icon: "i-Clock-4",
        name: "Turnos",
        path: "/turno/consulta",
        type: "link",
      },
      {
        icon: "i-Business-ManWoman",
        name: "Pessoas",
        path: "/",
        type: "dropDown",
        sub: [
          {
            icon: "i-Checked-User",
            name: "Alunos",
            path: "/aluno/consulta",
            type: "link",
          },
          {
            icon: "i-Diploma-2",
            name: "Educadores",
            path: "/professor/consulta",
            type: "link",
          },
          {
            icon: "i-Add-UserStar",
            name: "Rematrículas",
            path: "/rematricula/consulta",
            type: "link",
          },
          {
            icon: "i-File-Clipboard-File--Text",
            name: "Pré-cadastros",
            path: "/aluno/consultaPreCadastro",
            type: "link",
          },          
        ],
      },
      {
        icon: "i-Business-Mens",
        name: "Turmas",
        path: "/turma/consulta",
        type: "link",
      },
      {
        icon: "i-Calendar-4",
        name: "Calendário",
        path: "/calendario/cadastro",
        type: "link",
      },
      {
        icon: "i-Big-Data",
        name: "Biblioteca",
        description: "Biblioteca",
        type: "dropDown",
        sub: [
          {
            icon: "i-Book",
            name: "Livros",
            path: "/biblioteca/consulta",
            type: "link",
          },
          {
            icon: "i-Receipt-4",
            name: "Movimentação",
            path: "/biblioteca/movimentacoes",
            type: "link",
          },
        ],
      },
      {
        name: "Relatórios",
        description: "Relatórios",
        type: "dropDown",
        icon: "i-Magnifi-Glass1",
        sub: [
          {
            icon: "i-File-Horizontal-Text",
            name: "Matriculados",
            path: "/aluno/consulta",
            type: "link",
          },
          {
            icon: "i-File-Horizontal-Text",
            name: "Aniversariantes",
            path: "/consultas/aniversariantes/consulta",
            type: "link",
          },
          {
            icon: "i-File-Horizontal-Text",
            name: "Quadro Resumo",
            path: "/consultas/quadroresumo/consulta",
            type: "link",
          },
          {
            icon: "i-File-Horizontal-Text",
            name: "Históricos",
            path: "/aluno/historico",
            type: "link",
          },
          {
            icon: "i-File-Horizontal-Text",
            name: "Resumo de Alunos",
            path: "/consultas/resumoalunos/consulta",
            type: "link",
          },
          {
            icon: "i-File-Horizontal-Text",
            name: "Cardápio",
            path: "/consultas/cardapio/consulta",
            type: "link",
          },
          {
            icon: "i-File-Horizontal-Text",
            name: "Livros",
            path: "/consultas/livros/impressao",
            type: "link",
          },
          {
            icon: "i-File-Horizontal-Text",
            name: "Alunos Matriculados",
            path: "/consultas/alunosmatriculados/consulta",
            type: "link",
          },
        ],
      },
    ],
  },
  {
    name: "Pedagógico",
    description: "Pedagógico",
    type: "dropDown",
    icon: "i-Bookmark",
    sub: [
      {
        icon: "i-Network-Window",
        name: "Planejamento",
        path: "/planejamento/consulta",
        type: "link",
      },
      {
        name: "Moderação",
        description: "Moderação",
        type: "dropDown",
        icon: "i-Quotes",
        sub: [
          {
            icon: "i-Quotes-2",
            name: "Pareceres",
            path: "/parecerdescritivo/consulta",
            type: "link",
          },
          {
            icon: "i-Quotes-2",
            name: "Considerações",
            path: "/consideracao/consulta",
            type: "link",
          },
        ],
      },
      {
        name: "Relatórios",
        description: "Relatórios",
        type: "dropDown",
        icon: "i-Magnifi-Glass1",
        sub: [
          {
            icon: "i-File-Horizontal-Text",
            name: "Planejamento Diário",
            path: "/planejamentodiario/consulta",
            type: "link",
          },
          {
            icon: "i-File-Horizontal-Text",
            name: "Chamada",
            path: "/chamada/consulta",
            type: "link",
          },
          {
            icon: "i-File-Horizontal-Text",
            name: "Pareceres",
            path: "/consultas/parecerdescritivo/consulta",
            type: "link",
          },
        ],
      },
    ],
  },
  {
    name: "Agenda",
    description: "Agenda",
    type: "dropDown",
    icon: "i-Orientation-2",
    sub: [
      {
        icon: "i-Speach-Bubbles",
        name: "Mensagens",
        path: "/mensagem/cadastro",
        type: "link",
      },
      {
        icon: "i-File-Horizontal-Text",
        name: "Atividades",
        path: "/atividade/cadastro",
        type: "link",
      },
      {
        icon: "wm wm-prato",
        name: "Refeições",
        path: "/refeicao/cadastro",
        type: "link",
      },
      {
        icon: "wm wm-food-menu",
        name: "Cardápio",
        path: "/cardapio/consulta",
        type: "link",
      },
      {
        icon: "i-Newspaper",
        name: "Comunicados",
        path: "/comunicado/consulta",
        type: "link",
      },
      {
        icon: "i-Speach-Bubble-8",
        name: "Recados",
        path: "/recado/recados",
        type: "link",
      },      
    ],
  },
];

const navigationsFinanceiro = [
  {
    name: "Financeiro",
    description: "Financeiro",
    type: "dropDown",
    icon: "i-Coins",
    sub: [
      {
        icon: "i-Library",
        name: "Conta Contábil",
        path: "/contacontabil/consulta",
        type: "link",
      },
      {
        icon: "i-Shop-4",
        name: "Fornecedores",
        path: "/fornecedor/consulta",
        type: "link",
      },
      {
        icon: "i-Building",
        name: "Banco/Portador",
        path: "/portador/consulta",
        type: "link",
      },
      {
        icon: "i-Money-2",
        name: "Contas Pagar",
        path: "/contapagar/consulta",
        type: "link",
      },
      {
        name: "Conta Receber",
        description: "Contas a Receber",
        type: "dropDown",
        icon: "i-Financial",
        sub: [
          {
            icon: "i-Financial",
            name: "Contas Receber",
            path: "/contareceber/consulta",
            type: "link",
          },
          {
            icon: "i-File-Horizontal-Text",
            name: "Relatório",
            path: "/consultas/contareceber/consulta",
            type: "link",
          },
        ],
      },
      {
        name: "Livro Caixa",
        description: "Livro Caixa",
        type: "dropDown",
        icon: "i-Box-Full",
        sub: [
          {
            icon: "i-Box-Full",
            name: "Livro Caixa",
            path: "/livrocaixa/cadastro",
            type: "link",
          },
          {
            icon: "i-File-Horizontal-Text",
            name: "Relatório",
            path: "/consultas/livrocaixa/consulta",
            type: "link",
          },
        ],
      },
      {
        icon: "i-File-Horizontal-Text",
        name: "Títulos",
        path: "/titulo/consulta",
        type: "link",
      },
      {
        name: "Boletos",
        description: "Boletos2",
        type: "dropDown",
        icon: "i-Bar-Code",
        sub: [
          {
            icon: "i-Inbox-Out",
            name: "Remessa",
            path: "/boletos/remessa",
            type: "link",
          },
          {
            icon: "i-Inbox-Into",
            name: "Retorno",
            path: "/boletos/retorno",
            type: "link",
          },
          {
            icon: "i-Bar-Code",
            name: "Boletos",
            path: "/boletos/boletos",
            type: "link",
          },
        ],
      },
    ],
  },
];

const navigationsAdmin = [
  ...navigationsSecretaria,
  ...navigationsFinanceiro,
];

const retornaMenu = () => {
  try {
    switch ($auth.role) {
      case "ADMIN":
        return navigationsAdmin;
      case "SECRETARIA":
        return navigationsSecretaria;
      case "FINANCEIRO":
        return navigationsFinanceiro;
      case "PROFESSOR":
        return navigatiosProfessor;
      default:
        return [];
    }
  } catch (error) {
    return [];
  }
};

const navigatiosProfessor = [
  {
    name: "Dashboard",
    description: "Dashboard",
    type: "link",
    icon: "i-Dashboard",
    path: dashboardPath,
  },
  {
    icon: "i-Big-Data",
    name: "Biblioteca",
    description: "Biblioteca",
    type: "dropDown",
    sub: [
      {
        icon: "i-Receipt-4",
        name: "Movimentação",
        path: "/biblioteca/movimentacoes",
        type: "link",
      },
    ],
  },
];

export const navigations = retornaMenu();
